import { useRemoteMutation } from "../useRemote/useRemoteMutation";
import { RemoteApiError } from "../useRemote/types";
import { getOrgBackend } from "../../../app/backend";

export type CreateOrUpdateUserDto = {
  userId?: string;
  companyId: number;
  userEmail: string;
  isActive: boolean;
  activateFirstAid: boolean;
  participatesInMobileWorking: boolean;
  employeeResponsibleEmail: string;
  username: string;
  firstName: string;
  lastName: string;
  departmentId: number | null;
};

export function useRemoteCreateOrUpdateUser() {
  return useRemoteMutation<void, RemoteApiError, [CreateOrUpdateUserDto]>({
    key: "createOrUpdateUser",
    url: `${getOrgBackend()}/create-update-users`
  });
}
